export const TrendingStockColumns = [
    {
        Header: "SL No",
        accessor: "slNo",
    },
    {
        Header: "Name",
        accessor: "name",
    },
    {
        Header: "Price",
        accessor: "price",
    },
    {
        Header: "Return",
        accessor: "return",
    }
]

export const TrendingStockTableData = [
    {
        slNo: "01",
        name: "Trivago",
        price: "$520",
        return: "+5%",
        text_color: "text-success"
    },
    {
        slNo: "02",
        name: "Canon",
        price: "$820",
        return: "+5%",
        text_color: "text-success"
    },
    {
        slNo: "03",
        name: "Uber Food",
        price: "$220",
        return: "+5%",
        text_color: "text-success"
    },
    {
        slNo: "04",
        name: "Nokia",
        price: "$1020",
        return: "+5%",
        text_color: "text-success"
    },
    {
        slNo: "05",
        name: "Tiktok",
        price: "$900",
        return: "+5%",
        text_color: "text-success"
    },
]